module.exports = __webpack_public_path__ + "media/images/remember-logo-full-fd5d675a0d83d7d4bdc26d0dc8097261.svg";